import React from 'react';
import { useTranslation } from 'react-i18next';
import { getStoreUrl } from '../utils/storeUrls';
import { storeLinkProps } from '../utils/inAppBrowser';

const CTABanner = () => {
  const { t, i18n } = useTranslation();
  const storeUrl = getStoreUrl(i18n.language);

  return (
    <section style={{ background: 'var(--v2-bg)', color: 'var(--v2-ink)', position: 'relative', zIndex: 2 }} className="py-16 px-4">
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <div
          style={{
            margin: '0 0',
            borderRadius: '24px',
            background: 'linear-gradient(135deg, var(--v2-primary), var(--v2-violet-400))',
            padding: 'clamp(48px, 6vw, 80px) clamp(24px, 5vw, 64px)',
            textAlign: 'center',
          }}
        >
          <h2
            style={{
              fontSize: 'clamp(28px, 4vw, 48px)',
              fontWeight: 800,
              color: '#fff',
              marginBottom: '12px',
              lineHeight: 1.15,
            }}
          >
            {t('home.cta.title', 'Stop typing. Start talking.')}
          </h2>
          <p
            style={{
              fontSize: '18px',
              color: 'rgba(255,255,255,0.8)',
              marginBottom: '32px',
              maxWidth: '480px',
              margin: '0 auto 32px',
            }}
          >
            {t('home.cta.subtitle', 'Your first note in under 30 seconds. No credit card, no tutorial hell.')}
          </p>
          <a
            {...storeLinkProps(storeUrl)}
            style={{
              display: 'inline-block',
              background: '#fff',
              color: 'var(--v2-primary)',
              padding: '15px 36px',
              borderRadius: '999px',
              fontWeight: 700,
              fontSize: '16px',
              textDecoration: 'none',
              boxShadow: '0 4px 24px rgba(0,0,0,0.15)',
              transition: 'opacity 0.15s',
            }}
          >
            {t('home.cta.button', 'Download Notely AI →')}
          </a>
          <p style={{ color: 'rgba(255,255,255,0.55)', fontSize: '13px', marginTop: '14px' }}>
            {t('home.cta.note', 'Free to download. No credit card required.')}
          </p>
        </div>
      </div>
    </section>
  );
};

export default CTABanner;
